module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới hãng vận chuyển",
      "breadcrumbs": [{
        title: 'Quản lý hãng vận chuyển',
        route: {
          name: 'carrier'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "create-carrier-form",
    staticClass: "margin-top",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localCarrier,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localCarrier.name),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "name", $$v)
      },
      expression: "localCarrier.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tên rút gọn",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên rút gọn"
    },
    model: {
      value: (_vm.localCarrier.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "short_name", $$v)
      },
      expression: "localCarrier.short_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cân nặng quy đổi",
      "prop": "weight_rate"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cân nặng quy đổi"
    },
    model: {
      value: (_vm.localCarrier.weight_rate),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "weight_rate", $$v)
      },
      expression: "localCarrier.weight_rate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Logo"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadLogoUrl,
      "headers": _vm.uploadHeader,
      "show-file-list": false,
      "on-success": _vm.handleLogoUpload,
      "before-upload": _vm.beforeLogoUpload
    }
  }, [(_vm.logo.path) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.logo.path
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "VAT",
      "prop": "vat_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "VAT"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('vat_fee')
      },
      "blur": function($event) {
        return _vm.addZero('vat_fee')
      }
    },
    model: {
      value: (_vm.localCarrier.vat_fee),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "vat_fee", $$v)
      },
      expression: "localCarrier.vat_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí dịch vụ",
      "prop": "service_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí bảo hiểm"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('service_fee')
      },
      "blur": function($event) {
        return _vm.addZero('service_fee')
      }
    },
    model: {
      value: (_vm.localCarrier.service_fee),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "service_fee", $$v)
      },
      expression: "localCarrier.service_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí bảo hiểm",
      "prop": "insurrance_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí bảo hiểm"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('insurrance_fee')
      },
      "blur": function($event) {
        return _vm.addZero('insurrance_fee')
      }
    },
    model: {
      value: (_vm.localCarrier.insurrance_fee),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "insurrance_fee", $$v)
      },
      expression: "localCarrier.insurrance_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí xăng dầu",
      "prop": "oil_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí xăng dầu"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('oil_fee')
      },
      "blur": function($event) {
        return _vm.addZero('oil_fee')
      }
    },
    model: {
      value: (_vm.localCarrier.oil_fee),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "oil_fee", $$v)
      },
      expression: "localCarrier.oil_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "adddon-1",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hệ số vùng xa",
      "prop": "remote_area_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Hệ số vùng xa"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('remote_area_fee')
      },
      "blur": function($event) {
        return _vm.addZero('remote_area_fee')
      }
    },
    model: {
      value: (_vm.localCarrier.remote_area_fee),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "remote_area_fee", $$v)
      },
      expression: "localCarrier.remote_area_fee"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "append",
      "placeholder": "Select"
    },
    slot: "append",
    model: {
      value: (_vm.localCarrier.remote_area_unit),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "remote_area_unit", $$v)
      },
      expression: "localCarrier.remote_area_unit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "%",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "đ",
      "value": 1
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Url check mã vận đơn",
      "prop": "tracking_url"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Url check mã vận đơn"
    },
    model: {
      value: (_vm.localCarrier.tracking_url),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "tracking_url", $$v)
      },
      expression: "localCarrier.tracking_url"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ghi chú"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Ghi chú"
    },
    model: {
      value: (_vm.localCarrier.note),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "note", $$v)
      },
      expression: "localCarrier.note"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Giao hàng thu tiền",
      "prop": "is_cash"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.localCarrier.is_cash),
      callback: function($$v) {
        _vm.$set(_vm.localCarrier, "is_cash", $$v)
      },
      expression: "localCarrier.is_cash"
    }
  }, [_vm._v("Giao hàng thu tiền")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-026bf8f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carrier/NewCarrier.vue
// module id = 689
// module chunks = 1